const sereneFeelings = [
  'Ne pas préciser',
  'Calme',
  'Serein.e',
  'Paisible',
  'Zen',
];

export default sereneFeelings;
